import { render, staticRenderFns } from "./accountStep4.vue?vue&type=template&id=2ae2287b&"
import script from "./accountStep4.vue?vue&type=script&lang=js&"
export * from "./accountStep4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports